import { Record as ImmutableRecord, List, Map } from 'immutable';

import { mkPreferencesStore } from 'companion-app-components/flux/preferences/types';

import { defaultDatasetPreferences, defaultUserPreferences } from './defaults';

export type TransactionRegisterPreferences = {
  doubleAmounts: boolean;
  editDownloaded: boolean;
  deleteDownloaded: boolean;
  autoSave: boolean;
  splitsInDialog: boolean;
  autoSearch: boolean;
  longCats: boolean;
  continuousCreate: boolean;
  showCurrencySymbol: boolean;
  wrapText: boolean;
  showAccountColors: boolean;
  currencySymbol: string;
  registerComfort: 'normal' | 'compact' | 'cozy';
  regFieldsSort: {
    cashFlow: List<string>;
    credit: List<string>;
    investment?: List<string>;
  };
};

export type CalendarTransactionPreferences = {
  showTransactions: boolean;
  showScheduleTransactions: boolean;
  showDailyBalances: boolean;
  exceedingAmount: number | null;
  accountsToShow: string[] | null;
  dashboard: {
    showTransactions: boolean;
    showScheduleTransactions: boolean;
  };
};

export type QUICKENPreferences = {
  transactionRegister: TransactionRegisterPreferences;
  calendarTransaction: CalendarTransactionPreferences;
  accountsPrefs: Record<string, unknown> | null;
  accountBarBalanceType: 'today' | 'future' | string;
  accountBarShowCents: boolean;
  accountDrawerDefaultOpen: boolean;
  accountNodePrefs: Map<string, any>;
  projectedOpen: boolean;
  upcomingOpen: boolean;
  overviewPageLayout: List<unknown>;
  qCardsOffByDefault: boolean | null;
  autoRefresh: boolean;
  kioskmode: boolean;
  dateRangeProjectedBalances: 'thirty' | 'sixty' | 'ninety' | string;
  currencySymbol: string;
  theme: 'light' | 'dark' | 'system' | null;
};

export const Preferences = ImmutableRecord(
  {
    shared: {
      user: {
        ...defaultUserPreferences,
      },
      dataset: {
        webApp: {
          ...defaultDatasetPreferences,
        },
      },
    },
    /* these are not yet supported
    client: {
      user: {
      },
      dataset: {
      },
      global: {
      },
    },
    qcs: {},
    */
  },
);

export const PreferencesStore = ImmutableRecord({
  isLoading: undefined,
  loadPending: {
    shared: {
      user: true,
      dataset: true,
    },
  },
  preferences: new Preferences(),
  error: undefined,
});

export const initialPreferencesState = mkPreferencesStore({ preferences: new Preferences() });
